import React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PolarisIcon from '../PolarisIcon';

interface SchemaTemplateSelectProps {
  templates: any[];
  onChange: (data: any) => void;
  label: string;
}

export default function SchemaTemplateSelect({ label, templates, onChange }: SchemaTemplateSelectProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (value: string) => {
    onChange({ audio_track: templates[value as keyof typeof templates] });
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div style={{position: 'absolute', right: 20, zIndex: 9}}>
      <Button
        id={`${label}_button`}
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        endIcon={<PolarisIcon icon="down_caret" height={16} />}
      >
        {label}
      </Button>
      <Menu id={`${label}_menu`} anchorEl={anchorEl} open={open} onClose={handleClose} MenuListProps={{ 'aria-labelledby': `${label}_button` }}>
        {Object.keys(templates).map((key) => (
          <MenuItem key={key} onClick={() => handleClick(key)}>
            {key}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
